import React from 'react'
import Alert from '@material-ui/lab/Alert'
import ErrorIcon from '@material-ui/icons/Error'

export const PersonalEmailWarning = ({ marginTop = '0' }) => {
  return (
    <Alert
      severity="warning"
      icon={<ErrorIcon fontSize="inherit" />}
      style={{
        alignItems: 'center',
        marginBottom: '10px',
        padding: '0 8px',
        borderRadius: '8px',
        fontSize: '14px',
        marginTop,
      }}
    >
      <span>
        <b>Personal email detected:</b> Your access will be{' '}
        <b>limited to EDDM.</b>
        <br />
        Use your work email to access Promofy Ads (Flyering, Door Hanger, Direct
        Mail, EDDM, Insert Media and Promofy Design tool)
      </span>
    </Alert>
  )
}
